module.exports = __webpack_public_path__ + "img/bg1 (1).18a64e5d.jpg";